/* Callisto – produktsiden:
   1) Lagerlinjen: på hverdage før kl. 12 (dansk tid) står der "Sendes i dag" i stedet for "levering 1–2 dage".
   2) Gaveæske-linjen (tekstblok med link til /products/gaveaeske, se snippet claury-pdp-gift): "Tilkøb her" lægger en gaveæske i kurven med ét tryk. */
(function () {
  if (window.ClPdpExtras) return;

  /* ---------- 1) Sendes i dag ---------- */
  var SENDES = ' · Skickas i dag';
  function foerKl12() {
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', weekday: 'short', hour: 'numeric', hourCycle: 'h23' });
      var dag = '', time = 0;
      f.formatToParts(new Date()).forEach(function (p) {
        if (p.type === 'weekday') dag = p.value;
        if (p.type === 'hour') time = parseInt(p.value, 10);
      });
      return dag !== 'Sat' && dag !== 'Sun' && time < 12;
    } catch (e) { return false; }
  }
  function sendesIDag() {
    var idag = foerKl12();
    [].forEach.call(document.querySelectorAll('.pvj-service[data-main]:not(.is-out) .pvj-service__extra'), function (el) {
      if (el.textContent !== SENDES) el.setAttribute('data-cl-org', el.textContent);
      var vil = idag ? SENDES : el.getAttribute('data-cl-org');
      if (vil != null && el.textContent !== vil) el.textContent = vil;
    });
  }

  /* ---------- 2) Gaveæske: "Tilkøb her" i gaveæske-linjen (snippet claury-pdp-gift) lægger æsken i kurven ---------- */
  function laegIKurv(id) {
    if (window.CallistoCart && window.CallistoCart.add) return window.CallistoCart.add([{ id: id, quantity: 1 }], false);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('fejl'); return r.json(); });
  }
  /* Hele boksen er knappen. Lytter i "capture"-fasen, så temaets egne link-funktioner ikke sender kunden videre til gaveæsken */
  function tilfoej(box) {
    var id = Number(box.getAttribute('data-variant-id'));
    if (!id || box.classList.contains('is-busy')) return;
    var txt = box.querySelector('[data-cl-gift-txt]'), org = txt.innerHTML;
    box.classList.add('is-busy');
    txt.textContent = 'Lägger en extra presentask i varukorgen…';
    laegIKurv(id).then(function () {
      box.classList.remove('is-busy');
      box.classList.add('is-added');
      txt.textContent = 'Extra presentask lagd i varukorgen';
      setTimeout(function () { box.classList.remove('is-added'); txt.innerHTML = org; }, 2600);
    }).catch(function () { box.classList.remove('is-busy'); txt.innerHTML = org; });
  }
  document.addEventListener('click', function (e) {
    var box = e.target.closest && e.target.closest('[data-cl-gift]');
    if (!box) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (!box.classList.contains('is-added')) tilfoej(box);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var box = e.target.closest && e.target.closest('[data-cl-gift]');
    if (!box) return;
    e.preventDefault();
    if (!box.classList.contains('is-added')) tilfoej(box);
  }, true);

  /* ---------- Kør ved start og når siden ændrer sig (variantskift m.m.) ---------- */
  function koer() { sendesIDag(); }
  var venter = null;
  function start() {
    koer();
    new MutationObserver(function () { clearTimeout(venter); venter = setTimeout(koer, 60); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
    setInterval(sendesIDag, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.ClPdpExtras = { koer: koer };
})();
